<template>
  <div class="w-100 vh-100 bg-dark d-flex align-items-center">
    <div class="col-md-4 ml-auto mr-auto">
      <img src="/img/ScriptlyLogo.png" alt="">
      <div v-if="signInFailed" class="alert alert-danger" role="alert">
        Sign-in didn't complete. Select Get Started to try again.
      </div>
      <n-button type="primary" size="lg" round block @click="login">
        Get Started
      </n-button>
    </div>
  </div>
</template>

<script>
// Shown only to an MSAL or OIDC visitor with no account: the root route's guard sends everyone
// else on before this page renders (see util/homeLanding).
export default {
  name: "Login",
  data() {
    return {
      // Set at startup when MSAL rejected the response the sign-in returned with.
      signInFailed: this.$msalSignInFailed === true,
    };
  },
  methods: {
    async login() {
      if (window !== window.parent) {
        this.$msal.loginPopup();
      } else {
        this.$msal.loginRedirect();
      }
    },
  }
};
</script>

<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
</style>
